import { getSettingData } from "@/api/myPractice"
import { flatPlacticeInfo, isObjEmpty, completeAddress, sortByPriority } from "./helper";
import { getCountryList } from "@/api/va-order-page/pricing/shipping";

// The settings page and SettingForm both ask for the practice data on mount,
// and the parent's dispatch lands while the child's request is still in flight -
// at which point the isObjEmpty guard below has nothing to reject yet. Share the
// promise so concurrent callers wait on one request instead of firing their own.
let practiceInfoRequest = null

const practiceInfo = {
    namespaced: true,
    state: {
        old_personal: {},
        old_practice: {},
        infoURL: '/setting/getPracticeInfo',
        postpracticeURL: '/setting/setPracticeInfoClinic',
        postpersonalURL: '/setting/setPracticeInfoCustomer',
        countryOptions: [],
    },
    getters: {
        old_practice: state => state.old_practice,
        old_personal: state => state.old_personal,
        personalURL: state => state.postpersonalURL,
        practiceURL: state => state.postpracticeURL
    },
    mutations: {
        SET_PRACTICE_DATA(state, practice_obj) {
            state.old_practice = practice_obj
        },
        SET_PERSONAL_DATA(state, personal_obj) {
            state.old_personal = personal_obj
        },
        SET_COUNTRY_OPTIONS(state, countryList) {
            state.countryOptions = countryList;
        },
        SET_DEFAULT(state) {
            state.old_personal = {}
            state.old_practice = {}
        }
    },
    actions: {
        async getSettingData({ state, rootState, commit }, { force = false } = {}) {
            if (!force && !isObjEmpty(state.old_personal)) return;
            if (!practiceInfoRequest) {
                practiceInfoRequest = getSettingData(state.infoURL)
                    .finally(() => { practiceInfoRequest = null });
            }
            const res = await practiceInfoRequest;
            const practiceData = flatPlacticeInfo(completeAddress(res.data.practice))
            practiceData.default_customer = res.data.default_customer
            practiceData.clinicId = String(rootState.myPractice.userInfo.clinicId);
            const personalData = flatPlacticeInfo(completeAddress(res.data.personal))
            personalData.clinicId = String(rootState.myPractice.userInfo.clinicId);
            commit("SET_PRACTICE_DATA", practiceData)
            commit("SET_PERSONAL_DATA", personalData)
        },
        setPracticeData({ commit }, practiceData) {
            commit("SET_PRACTICE_DATA", practiceData)
        },
        setPersonalData({ commit }, personalData) {
            commit("SET_PERSONAL_DATA", personalData)
        },
        async setCountryOptions({ state, commit }) {
            if (state.countryOptions.length === 0) {
                let { data } = await getCountryList();
                data = sortByPriority(data);
                data.forEach(country => {
                    country.label = country.countryName + " (" + country.countryNameTwoBytes + ")";
                    country.value = country.countryNameTwoBytes;
                });
                commit("SET_COUNTRY_OPTIONS", data);
            }

        },

    },
}


export default practiceInfo;